import * as tools from '../Tools';

export default class DataMap {
    readonly url = '/Handler/MapData';

    protected mapContainer: SVGElement = null;
    protected stationContainer: HTMLElement = null;
    protected svgInit: HTMLElement = null;

    constructor() {
        this.mapContainer = <SVGElement>(<unknown>document.getElementById('karte'));
        if (!this.mapContainer) {
            return;
        }
        const _this = this;
        _this.stationContainer = document.getElementById('layer-station');
        _this.svgInit = document.getElementById('svgInit');
        var openedTooltip = null;
        $('.tabs-2 li a').on('click', function (event) {
            if (openedTooltip !== null) {
                openedTooltip.tooltip('close');
            }
        });

        this.mapContainer
            .querySelectorAll(
                '#Hauptgewaesser path, #Nebengewaesser path, #Staedte polygon,#Staedte use, #Wetterstationen use,#Talsperren polygon,#Talsperren use, #Pegel use'
            )
            .forEach((el: HTMLElement) => {
                if (el.dataset.id) {
                    el.addEventListener('click', () => {
                        _this.fetchStation(el);
                    });
                }
            });
        _this.registerFilterStations();
    }

    registerFilterStations() {
        const _this = this;
        document.querySelectorAll('.map-options input').forEach((el: HTMLInputElement) => {
            el.addEventListener('change', () => {
                _this.filterStations(el);
            });
            _this.filterStations(el);
        });
    }

    filterStations(el: HTMLInputElement) {
        if (el.checked) {
            $('#karte use[data-type="' + el.dataset.type + '"]').show();
        } else {
            $('#karte use[data-type="' + el.dataset.type + '"]').hide();
            var $el = $(
                '#karte use[data-id="' +
                    $('#karte-drag').attr('data-id') +
                    '"][data-type="' +
                    $('#karte-drag').attr('data-type') +
                    '"]'
            );
            $el.show();
        }
    }

    stationStatus(data: IDataMap) {
        if (data.statusPublic === -1) {
            // Wenn kein öffentlicher Status vorhanden ist, den errechneten nutzen
            data.statusPublic = data.statusHvd;
        }
        switch (data.statusPublic) {
            case 0:
                return 'Normal';
            case 1:
                return 'Mittel';
            case 2:
                return 'Hoch';
            default:
                return 'Unbekannt';
        }
    }

    async fetchStation(el: HTMLElement) {
        const _this = this;
        _this.svgInit.style.display = '';
        const data: IDataMap = await tools.fetchPOST(_this.url, {
            sid: el.dataset.id,
            type: el.dataset.type
        });
        if (<any>data !== -1) {
            _this.stationContainer.querySelector('.lbl-abfluss').textContent = data.text;
            if (data.referenz && data.referenz !== '') {
                _this.stationContainer.querySelector('.row-0 div').innerHTML =
                    '<i class="icon icon-' +
                    data.type +
                    '"></i> ' +
                    data.name +
                    '<br />Referenzstation: ' +
                    data.referenz;
            } else {
                _this.stationContainer.querySelector('.row-0 div').innerHTML =
                    '<i class="icon icon-' + data.type + '"></i> ' + data.name;
            }
            _this.stationContainer.querySelector('.val-abfluss').textContent =
                data.value + ' ' + data.unit;
            _this.stationContainer.querySelector('.val-date').textContent = data.date;

            if (data.statusPublic === 3) {
                _this.stationContainer.querySelector('.lbl-warn').textContent = '';
                _this.stationContainer.querySelector('.val-warn').textContent = '';
            } else {
                _this.stationContainer.querySelector('.lbl-warn').textContent = 'Warnstufe';
                _this.stationContainer.querySelector('.val-warn').textContent =
                    _this.stationStatus(data);
            }
            if (data.path !== '') {
                _this.stationContainer.querySelector('.val-link').innerHTML =
                    '<i class="icon-right-dir"></i> <a href="' + data.path + '">Zur Station</a>';
            } else {
                _this.stationContainer.querySelector('.val-link').innerHTML =
                    'Keine Seite vorhanden: ' + data.type + ' ' + data.name;
            }
            _this.stationContainer.querySelector('.title').textContent = data.name;

            _this.stationContainer.style.display = '';
        }
        _this.svgInit.style.display = 'none';
    }
}
